import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
  Divider,
  useTheme,
  Button,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CookieIcon from '@mui/icons-material/Cookie';

const Footer = ({ onOpenCookieSettings }) => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: theme.palette.mode === 'dark' ? 'background.paper' : '#f5f5f5',
        borderTop: `1px solid ${theme.palette.divider}`,
        py: 3,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'center', sm: 'flex-start' },
            gap: 2,
          }}
        >
          {/* Brand and Copyright */}
          <Box sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
            <Typography
              variant="h6"
              sx={{
                color: theme.palette.primary.main,
                fontWeight: 600,
                mb: 0.5,
              }}
            >
              FamilyForLife
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Connecting families, preserving memories
            </Typography>
          </Box>

          {/* Legal Links */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'center',
              gap: { xs: 1, sm: 2 },
            }}
          >
            <Link
              component={RouterLink}
              to="/privacy"
              color="text.secondary"
              underline="hover"
              variant="body2"
            >
              Privacy Policy
            </Link>
            <Link
              component={RouterLink}
              to="/terms"
              color="text.secondary"
              underline="hover"
              variant="body2"
            >
              Terms of Service
            </Link>
            <Link
              component={RouterLink}
              to="/cookies"
              color="text.secondary"
              underline="hover"
              variant="body2"
            >
              Cookie Policy
            </Link>
            {onOpenCookieSettings && (
              <Button
                size="small"
                startIcon={<CookieIcon fontSize="small" />}
                onClick={onOpenCookieSettings}
                sx={{
                  color: 'text.secondary',
                  textTransform: 'none',
                  fontSize: '0.875rem',
                  minWidth: 'auto',
                  p: 0,
                  '&:hover': {
                    bgcolor: 'transparent',
                    color: 'primary.main',
                  },
                }}
              >
                Cookie Settings
              </Button>
            )}
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Typography variant="caption" color="text.secondary">
            {currentYear} FamilyForLife. All rights reserved.
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Made with care for families everywhere
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
